module.exports = __webpack_public_path__ + "img/western_sahara.28a7a7b.webp";